import { useEffect } from 'react';

const useBeforeUnload = (isActive, message = '¿Estás seguro de que quieres abandonar? Los datos de la simulación se perderán.') => {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isActive) {
        event.preventDefault();
        event.returnValue = message;
        return message;
      }
    };

    const handlePopState = (event) => {
      if (isActive) {
        const confirmMessage = message;
        const userWantsToLeave = window.confirm(confirmMessage);
        
        if (!userWantsToLeave) {
          // Prevenir la navegación hacia atrás
          event.preventDefault();
          // Agregar la entrada actual de nuevo al historial
          window.history.pushState(null, '', window.location.pathname);
        }
      }
    };

    if (isActive) {
      // Agregar una entrada al historial para poder detectar el popstate
      window.history.pushState(null, '', window.location.pathname);
      
      window.addEventListener('beforeunload', handleBeforeUnload);
      window.addEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isActive, message]);
};

export default useBeforeUnload; 